import { useCraftingResolver } from '../services/craftingResolverContext';
import { resolveItemDisplayName, resolveItemKeyDisplayName } from '../services/itemDisplayName';
import type { ItemStack } from '../models/itemStack';

export function useItemName() {
    const resolver = useCraftingResolver();

    return {
        itemName: (key: string, snbt?: string | null) =>
            resolveItemKeyDisplayName(key, snbt, resolver()),
        stackName: (stack: Pick<ItemStack, 'itemId' | 'damage' | 'snbt' | 'name'>) =>
            resolveItemDisplayName(stack, resolver()),
        // Undefined for an unknown key, so the quantity formatters fall back to their own default.
        stackSize: (key: string): number | undefined => resolver()?.getItem(key)?.stackSize,
    };
}
